var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all"},[_c('h2',[_vm._v("即将离开中文知识网")]),_c('p',[_vm._v("您即将进入百科在线，点击“继续访问”可查看具体内容。")]),_c('p',[_vm._v(" 中文知识网是国家知识服务平台融合出版分平台，是中文集团旗下子公司运营的知识服务平台。中文知识网拥有百家在线、百科在线、同行评议等子平台。请放心跳转。 ")]),_c('div',{staticClass:"bottom"},[_c('div',{staticClass:"button",on:{"click":function($event){return _vm.openbaike()}}},[_vm._v("继续访问")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }